import type { UseAsyncDataResT } from '@dr.pogodin/react-utils';

import { type ListUsersQueryT, listUsers } from 'services';

import {
  type UserListT,
  newAsyncDataEnvelope,
  useAsyncData,
  useGlobalStateObject,
} from 'utils';

export function useUserList(
  query: ListUsersQueryT,
): UseAsyncDataResT<UserListT> {
  const gs = useGlobalStateObject();

  return useAsyncData(
    'users.list',

    async () => {
      const res = await listUsers(query);

      for (const user of res.users) {
        const path = `users.map.${user.id}` as const;
        const prev = gs.get(path);
        gs.set(`users.map.${user.id}`, newAsyncDataEnvelope(user, {
          numRefs: prev?.numRefs,
          timestamp: Date.now(),
        }));
      }

      return res;
    },

    {
      deps: [
        query.kind,
        query.page,
        query.pageSize,
        query.sort,
      ],
    },
  );
}
